import { Component, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'biel-sources',
  styleUrl: 'biel-sources.css',
  shadow: true,
})
export class BielSources {
  @Prop() sources: { title: string; url: string }[];
  @Prop() sourcesText: string = 'Sources';
  @State() showSources: boolean = false;

  toggleSources() {
    this.showSources = !this.showSources;
  }

  render() {
    return (
      <div class="biel-message__sources" part="container">
        <button
          class="biel-message__sources-toggle"
          part="toggle-button"
          onClick={() => this.toggleSources()}
        >
          <span>{this.sourcesText}</span>
          {this.showSources ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-up"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-down"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          )}
        </button>
        {this.showSources && (
          <div class="biel-message__sources-list" part="list">
            {this.sources.map((source) => (
              <a
                class="biel-message__source-card"
                part="item"
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                  <path d="M14 2v6h6" />
                  <line x1="16" x2="8" y1="13" y2="13" />
                  <line x1="16" x2="8" y1="17" y2="17" />
                  <line x1="10" x2="8" y1="9" y2="9" />
                </svg>
                <span class="biel-message__source-title">{source.title}</span>
              </a>
            ))}
          </div>
        )}
      </div>
    );
  }
}
